import { getSystemDetails } from "./formatting";

// Sorting utility function
export const sortData = (data, config, systems) => {
  if (!config || !config.key) return data;

  return [...data].sort((a, b) => {
    let aValue = a[config.key];
    let bValue = b[config.key];

    // Handle nested values (like systemDetails)
    if (config.key === 'project_id' || config.key === 'software_id') {
      aValue = getSystemDetails(systems, a.uuid)?.[config.key] || '';
      bValue = getSystemDetails(systems, b.uuid)?.[config.key] || '';
    }

    // Handle dates
    if (config.key.includes('date') || config.key.includes('registered_at') || config.key.includes('end_date') || config.key.includes('start_date')) {
      aValue = new Date(aValue || 0).getTime();
      bValue = new Date(bValue || 0).getTime();
    }

    // Handle boolean (AMC status)
    if (config.key === 'amc') {
      aValue = aValue ? 1 : 0;
      bValue = bValue ? 1 : 0;
    }

    // Handle status strings (Active/Expired, Online/Offline)
    if (config.key === 'status') {
      aValue = aValue === 'online' || aValue === 'Active' ? 1 : 0;
      bValue = bValue === 'online' || bValue === 'Active' ? 1 : 0;
    }

    // Handle strings
    if (typeof aValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }

    // Handle numbers
    if (typeof aValue === 'number') {
      return config.direction === 'asc' ? aValue - bValue : bValue - aValue;
    }

    // Handle strings and other types
    if (aValue < bValue) return config.direction === 'asc' ? -1 : 1;
    if (aValue > bValue) return config.direction === 'asc' ? 1 : -1;
    return 0;
  });
};
